import React, { useEffect, useState } from 'react';
import StockMetricTable from './StockMetricTable';


const HistoryComponent = () => {
  const[stockOrders, setStockOrders] = useState([]);

  useEffect(() => {

    const fetchStockOrders = async () => {
        try {
            console.log("fetching stock orders data");
            const url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_STOCK_SERVICE_DEV : "";

            const response = await fetch(url + '/stockorders');
            console.log("response:", response);
            const result = await response.json();
            console.log("result:", result);
            setStockOrders(result);

        } catch (error) {
            console.error("Error fetch stock orders. ", error);
        }
    };

    fetchStockOrders();
  }, []);

    const columns = [
      {
        Header: 'ticker',
        accessor: 'ticker', // accessor is the "key" in the data
      },
      {
        Header: 'Update Date',
        accessor: 'updateDate',
      },
      {
        Header: 'Order Id',
        accessor: 'orderId',
      },
      {
        Header: 'Amount',
        accessor: 'amount',
      },
      {
        Header: 'quantity',
        accessor: 'quantity',
      },
      {
        Header: 'Price',
        accessor: 'price',
      }
    ];

      return (
          <React.Fragment>
              <div>
                  <h1>Order History Table</h1>
                  <StockMetricTable columns={columns} data={stockOrders}></StockMetricTable>
              </div>
          </React.Fragment>
      );

};

export default HistoryComponent;